import { FC, TextareaHTMLAttributes } from "react";

import styles from "./form.module.css";
import textareaStyles from "./FormTextarea.module.css";

interface Props extends Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  "onChange" | "value"
> {
  value: string;
  error?: string | null;
  onValueChange: (value: string) => void;
}

export const FormTextarea: FC<Props> = ({
  error,
  onValueChange,
  ...textareaProps
}) => (
  <label className={styles.field}>
    <textarea
      {...textareaProps}
      className={`${styles.input} ${textareaStyles.textarea} ${error ? styles.inputInvalid : ""}`}
      aria-invalid={Boolean(error)}
      onChange={(event) => onValueChange(event.target.value)}
    />
    {error && <span className={styles.error}>{error}</span>}
  </label>
);
